import React from 'react';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { usePartners, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const PartnerManagementPage = () => {
  const { t } = useTranslation();

  return (
    <DynamicCrudPage
      entityType="partners"
      hook={usePartners}
      additionalHooks={{
        companies: useCompanies,
      }}
      addButtonTextKey="table.actions.addPartner"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="partner"
    />
  );
};

export default PartnerManagementPage;